import Resource from "../../entities/resource";

/**
 * Resource actions
 *
 * Call order:
 *
 * RESOURCE_SAVE_QUEUE:	adds the item to the save queue
 * --> RESOURCE_SAVE:	modifies the state
 * --> RESOURCE_SAVE_SUCCESS: if all went well
 * --> RESOURCE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail RESOURCE_SAVE_QUEUE is during the call to RESOURCE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const RESOURCE_FETCH_ONE_QUEUE: any = 'RESOURCE_FETCH_ONE_QUEUE';
export const RESOURCE_FETCH_SUCCESS: any = 'RESOURCE_FETCH_SUCCESS';
export const RESOURCE_FETCH_FAILURE: any = 'RESOURCE_FETCH_FAILURE';
export const RESOURCE_FETCH_ONE_SUCCESS: any = 'RESOURCE_FETCH_ONE_SUCCESS';
export const RESOURCE_FETCH_ONE_FAILURE: any = 'RESOURCE_FETCH_ONE_FAILURE';

export const RESOURCE_SAVE: any = 'RESOURCE_SAVE';
export const RESOURCE_SAVE_QUEUE: any = 'RESOURCE_SAVE_QUEUE';
export const RESOURCE_SAVE_SUCCESS: any = 'RESOURCE_SAVE_SUCCESS';
export const RESOURCE_SAVE_FAILURE: any = 'RESOURCE_SAVE_FAILURE';

export const RESOURCE_SAVE_MANY: any = 'RESOURCE_SAVE_MANY';
export const RESOURCE_SAVE_MANY_QUEUE: any = 'RESOURCE_SAVE_MANY_QUEUE';
export const RESOURCE_SAVE_MANY_SUCCESS: any = 'RESOURCE_SAVE_MANY_SUCCESS';
export const RESOURCE_SAVE_MANY_FAILURE: any = 'RESOURCE_SAVE_MANY_FAILURE';

export const RESOURCE_REMOVE: any = 'RESOURCE_REMOVE';
export const RESOURCE_REMOVE_QUEUE: any = 'RESOURCE_REMOVE_QUEUE';
export const RESOURCE_REMOVE_SUCCESS: any = 'RESOURCE_REMOVE_SUCCESS';
export const RESOURCE_REMOVE_FAILURE: any = 'RESOURCE_REMOVE_FAILURE';

export const RESOURCE_RESTORE: any = 'RESOURCE_RESTORE';
export const RESOURCE_RESTORE_QUEUE: any = 'RESOURCE_RESTORE_QUEUE';
export const RESOURCE_RESTORE_SUCCESS: any = 'RESOURCE_RESTORE_SUCCESS';
export const RESOURCE_RESTORE_FAILURE: any = 'RESOURCE_RESTORE_FAILURE';

export const RESOURCE_RESTORE_MANY: any = 'RESOURCE_RESTORE_MANY';
export const RESOURCE_REMOVE_MANY: any = 'RESOURCE_REMOVE_MANY';

/* Fetch actions */
export const fetchResourceSuccess = (resources: Resource[], partial: boolean, lastFetch: number) => ({type: RESOURCE_FETCH_SUCCESS, resources, partial, lastFetch});
export const fetchResourceFailure = (err: any) => {
		console.error('ResourceAction: fetchResourceFailure', err);
		return {type: RESOURCE_FETCH_FAILURE, err};
};
export const fetchOneResourceQueue = (resourceId: string) => ({type: RESOURCE_FETCH_ONE_QUEUE, resourceId});
export const fetchOneResourceSuccess = (resource: Resource) => ({type: RESOURCE_FETCH_ONE_SUCCESS, resource});
export const fetchOneResourceFailure = (id: string, err: any) => {
		console.error('ResourceAction: fetchOneResourceFailure', err);
		return {type: RESOURCE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveResource = (resource: Resource) => {
    // console.debug('⮂ RESOURCE_SAVE action', resource?.id);
    return {type: RESOURCE_SAVE, resource};
}
export const saveResourceQueue = (resource: Resource) => {
    // console.debug('⮂ RESOURCE_SAVE_QUEUE action', resource?.id);
    return {type: RESOURCE_SAVE_QUEUE, resource};
}
export const saveResourceSuccess = (resource: Resource) => {
    // console.debug('⮂ RESOURCE_SAVE_SUCCESS action', resource?.id);
    return {type: RESOURCE_SAVE_SUCCESS, resource};
}
export const saveResourceFailure = (resource: Resource, status: number, message: string) => {
    console.warn(`⮂ RESOURCE_SAVE_FAILURE error saving resource: HTTP ${status}: ${message}`, resource?.id);
    return {type: RESOURCE_SAVE_FAILURE, resource, status, message};
};

/* SaveMany actions */
export const saveManyResources = (resources: Resource[]) => {
    // console.debug('⮂ RESOURCE_SAVE_MANY action', resources?.map(resource => resource?.id).join(','));
    return {type: RESOURCE_SAVE_MANY, resources};
}
export const saveManyResourcesQueue = (resources: Resource[]) => {
    // console.debug('⮂ RESOURCE_SAVE_MANY_QUEUE action', resources?.map(resource => resource.id).join(','));
    return {type: RESOURCE_SAVE_MANY_QUEUE, resources};
}

export const saveManyResourcesSuccess = (resources: Resource[]) => {
    // console.debug('⮂ RESOURCE_SAVE_MANY_SUCCESS action', resources?.map(resource => resource.id).join(','));
    return {type: RESOURCE_SAVE_MANY_SUCCESS, resources};
}
export const saveManyResourcesFailure = (resources: Resource[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_RESOURCES_FAILURE Error saving resources: HTTP ${status}: ${message}`, resources?.map(resource => resource.id).join(','));
		return {type: RESOURCE_SAVE_MANY_FAILURE, resources, status, message};
};

/* Remove actions */
export const removeResource = (resource: Resource) => ({ type: RESOURCE_REMOVE, resource });
export const removeResourceQueue = (resource: Resource) => ({ type: RESOURCE_REMOVE_QUEUE, resource });
export const removeResourceSuccess = (resource: Resource) => ({ type: RESOURCE_REMOVE_SUCCESS, resource });
export const removeResourceFailure = (resource: Resource, status: number, message: string) => {
	console.error(`Redux: removeResourceFailure Error removing resource: HTTP ${status}: ${message}`);
	return ({ type: RESOURCE_REMOVE_FAILURE, resource, status, message });
};

/* Restore actions */
export const restoreResource = (resource: Resource) => ({ type: RESOURCE_RESTORE, resource });
export const restoreResourceQueue = (resource: Resource) => ({ type: RESOURCE_RESTORE_QUEUE, resource });
export const restoreResourceSuccess = (resource: Resource) => ({ type: RESOURCE_RESTORE_SUCCESS, resource });
export const restoreResourceFailure = (resource: Resource, status: number, message: string) => {
	console.error(`Redux: restoreResourceFailure Error restoring resource: HTTP ${status}: ${message}`);
	return ({ type: RESOURCE_RESTORE_FAILURE, resource, status, message });
};

/* RestoreMany actions */
export const restoreManyResources = (resources: Resource[]) => ({ type: RESOURCE_RESTORE_MANY, resources });

/* RemoveMany actions */
export const removeManyResources = (resources: Resource[]) => ({ type: RESOURCE_REMOVE_MANY, resources });